import { observer } from 'mobx-react';
import React from 'react';
import { Color, Flex, Heading, Link, Text } from 'component-library';
import { makeStyles } from '@material-ui/core';
import { SUPPORT_EMAIL_ADDRESS } from 'lib/constants';

const useStyles = makeStyles({
  helpBar: {
    height: '106px',
    backgroundColor: Color.neutral._light_20,
    borderRadius: '4px',
  },
  heading: {
    paddingBottom: '4px',
    lineHeight: '30px',
  },
});

export interface ResourceHelpBarProps {
  supportMailtoHref: string;
}

const ResourceHelpBar: React.FC<ResourceHelpBarProps> = observer(
  ({ supportMailtoHref }: ResourceHelpBarProps) => {
    const classes = useStyles();

    return (
      <Flex
        className={classes.helpBar}
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        padding={24}
      >
        <Flex direction='column' dataTestId='help-bar'>
          <Heading
            tag='h5'
            variant='medium'
            text='Need help?'
            className={classes.heading}
            noMargin={true}
          />
          <Text color={Color.neutral._80}>
            Email us at{' '}
            <Link
              href={supportMailtoHref}
              text={SUPPORT_EMAIL_ADDRESS}
              dataTestId='help-bar-email-link'
              variant='medium'
              omitIcon
            />{' '}
            and we&apos;ll get back to you shortly.
          </Text>
        </Flex>
      </Flex>
    );
  },
);

export default ResourceHelpBar;
